<div class="monitor-details-content">
  <div class="details-card">
    <div class="card-header">
      <div class="header-content">
        <h2>Detalles de Monitor</h2>
        <p>Información completa del monitor</p>
      </div>

      <button mat-icon-button (click)="showHelp()" matTooltip="Ayuda" class="help-button">
        <mat-icon>help_outline</mat-icon>
      </button>

      <button mat-icon-button (click)="closeDetails()" matTooltip="Cerrar detalle" class="close-button">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>

    <div class="divider"></div>

    @if (monitorsList().length > 0) {
      <div class="card-content">
        <!-- Selector de Monitores -->
        <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 16px;" class="monitor-select">
          <mat-label>Seleccionar Monitor</mat-label>
          <mat-select [formControl]="monitorControl">
            @for (m of monitorsList(); track m) {
              <mat-option [value]="m.id">
                {{ m.name || 'Sin nombre' }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-tab-group animationDuration="1000ms" class="monitor-tabs-section">
          <!-- ============ TAB ALARMAS ============ -->
          <mat-tab label="Alarmas" class="events-colors-section">
            <div class="alarmas-content">
              <!-- Tabla Colores -->
              @if (eventColorsArray().length > 0) {
                <div class="event-table-section">
                  <div class="event-table-wrapper">
                    <table mat-table [dataSource]="eventColorsArray()" class="mat-elevation-z2">
                      <ng-container matColumnDef="eventName">
                        <th mat-header-cell *matHeaderCellDef>Evento</th>
                        <td mat-cell *matCellDef="let item">{{ item.eventName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="color">
                        <th mat-header-cell *matHeaderCellDef>Color</th>
                        <td mat-cell *matCellDef="let item">
                          <span class="color-box" [style.backgroundColor]="item.color"></span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let item; let i = index">
                          <button mat-icon-button color="warn" (click)="deleteColor(i)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsWithActions"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsWithActions"></tr>
                    </table>
                  </div>
                </div>
              }
              @if (!eventColorsArray().length) {
                <div class="no-events">
                  No hay colores configurados para este monitor.
                </div>
              }
              <!-- Botón agregar color -->
              @if (!showAddColorForm()) {
                <div class="add-color-btn">
                  <button mat-raised-button (click)="toggleAddColorForm()">Añadir Color</button>
                </div>
              }
              <!-- Formulario agregar color -->
              @if (showAddColorForm()) {
                <div>
                  <form (ngSubmit)="addColor()">
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Evento / Alarma</mat-label>
                      <input matInput type="text" [formControl]="eventoControl" [matAutocomplete]="auto">
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onEventoSelected($event.option.value)">
                        @for (evento of filteredEventos$ | async; track evento) {
                          <mat-option [value]="evento">
                            {{ evento.desc_es }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Color</mat-label>
                      <input matInput type="color" [(ngModel)]="newColor.color" name="color" required>
                    </mat-form-field>
                    <div class="form-buttons">
                      <button mat-raised-button color="primary" type="submit">Guardar</button>
                      <button mat-button type="button" (click)="cancelForm()">Cancelar</button>
                    </div>
                  </form>
                </div>
              }
            </div>
          </mat-tab>
          <!-- ============ TAB USUARIOS ============ -->
          <mat-tab label="Usuarios">
            <div class="alarmas¿-content">
              <!-- Tabla de Usuarios -->
              @if (tableUsersArray().length > 0) {
                <div class="event-table-section">
                  <div class="event-table-wrapper">
                    <table mat-table [dataSource]="tableUsersArray()" class="mat-elevation-z2">
                      <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td mat-cell *matCellDef="let item">{{ item.name }}</td>
                      </ng-container>
                      <ng-container matColumnDef="apellido">
                        <th mat-header-cell *matHeaderCellDef>Apellido</th>
                        <td mat-cell *matCellDef="let item">{{ item.familyName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let item; let i = index">
                          <button mat-icon-button color="warn" (click)="deleteUser(i)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedUserColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedUserColumns"></tr>
                    </table>
                  </div>
                </div>
              }
              @if (!tableUsersArray().length) {
                <div class="no-events">
                  No hay usuarios configurados para este monitor.
                </div>
              }
              <!-- Botón mostrar formulario -->
              @if (!showAddUserForm()) {
                <div class="add-color-btn">
                  <button mat-raised-button (click)="toggleAddUserForm()">Añadir Usuario</button>
                </div>
              }
              <!-- Formulario agregar usuario -->
              @if (showAddUserForm()) {
                <div>
                  <form (ngSubmit)="addUser()">
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Usuarios</mat-label>
                      <input type="text" matInput [formControl]="userControl" [matAutocomplete]="autoUsers"
                        placeholder="Buscar usuario..." />
                      <mat-autocomplete #autoUsers="matAutocomplete" (optionSelected)="onUserSelected($event.option.value)">
                        @for (user of filteredUsers$ | async; track user) {
                          <mat-option [value]="user">
                            {{ user.name }} {{ user.familyName }} - {{ user.email }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <div class="form-buttons">
                      <button mat-raised-button color="primary" type="submit">Guardar</button>
                      <button mat-button type="button" (click)="cancelUserForm()">Cancelar</button>
                    </div>
                  </form>
                </div>
              }
            </div>
          </mat-tab>
          <mat-tab label="Vistas">
            <div class="vistas-content">
              <form (ngSubmit)="saveViews()" #viewsForm="ngForm" class="views-form">
                <p>Seleccione la(s) vista(s) para este monitor (al menos una):</p>
                <mat-checkbox [(ngModel)]="showMapValue" name="showMap">Mapa</mat-checkbox>
                <mat-checkbox [(ngModel)]="showTableValue" name="showTable">Tabla</mat-checkbox>
                @if (!showMap() && !showTable()) {
                  <div class="validation-error" style="color:#d32f2f; margin-top:8px;">
                    Debe seleccionar al menos 'Mapa' o 'Tabla'.
                  </div>
                }
                <div class="form-buttons" style="margin-top:12px;">
                  <button mat-raised-button color="primary" type="submit"
                  [disabled]="!showMap() && !showTable()">Guardar</button>
                  <button mat-button type="button" (click)="resetViews()">Cancelar</button>
                </div>
              </form>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </div>
</div>